import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export default function PrintSpin() {
  return (
    <div className="bg-[#00000099] h-dvh w-full fixed top-0 left-0 bottom-0 right-0 z-[9999] flex justify-center items-center">
      <Spin
        indicator={
          <LoadingOutlined style={{ fontSize: 60, color: "#fff" }} spin />
        }
      />
    </div>
  );
}
